<div class="help-txt" fxLayout="column" fxLayoutGap="10px" fxLayoutAlign="start stretch">
  <mat-icon class="aside-icon">information</mat-icon>
  <div class="body-text">
    {{locale.translate('knowledge_card_help_desc_b1')}}
  </div>

  <div class="body-text">
    {{locale.translate('knowledge_card_help_desc_b2')}}
  </div>
</div>
